export default __webpack_public_path__ + "static/8-d96cbce029c078519a7a346a0957701d.jpg";